const user = {
	namespaced: true,
	state: {
		productFilterList: [],
		baList: [],
		storeStateList: []
	},
	mutations: {
		SET_ProductFilterList: (state, data) => {
      state.productFilterList = data
    },
		SET_BaList: (state, data) => {
			state.baList = data
		},
		SET_StoreStateList: (state, data) => {
			state.storeStateList = data
		}
	},
	actions: {}
}

export default user